import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {CurrencyPipe, DecimalPipe, NgFor, NgIf} from "@angular/common";
import {ModalHeaderComponent} from '../../../layout/modal-header/modal-header.component';
import {AdditionalCostsInterface} from "../../../interfaces/workspace/additional-costs.interface";
import {ADDITIONAL_COST_VENDORS, AdditionalCostVendorConfig} from "../../../../../assets/data/additional-cost-vendors";

@Component({
    selector: 'app-info-additional-cost-details',
    templateUrl: './info-additional-cost-details.component.html',
    styleUrls: ['./info-additional-cost-details.component.scss'],
  imports: [
    MatDialogModule,
    ModalHeaderComponent,
    NgIf,
    NgFor,
    CurrencyPipe,
    DecimalPipe
  ]
})
export class InfoAdditionalCostDetailsComponent {
  protected readonly vendors: AdditionalCostVendorConfig[] = ADDITIONAL_COST_VENDORS

  constructor(
    public dialogRef: MatDialogRef<InfoAdditionalCostDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      additionalCost: AdditionalCostsInterface,
      availableCredits: number,
      recurrentCredits: number
    },
  ) {
    console.log('Additional cost data', this.data)
  }

  get finalTotal(): number {
    return Math.max(
      0,
      this.data.additionalCost.total - (this.data.availableCredits || 0) - (this.data.recurrentCredits || 0)
    )
  }

  get remainingCredits(): number {
    return Math.max(
      0,
      (this.data.availableCredits || 0) + (this.data.recurrentCredits || 0) - this.data.additionalCost.total
    )
  }
}
